import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Container } from "@movicoders/di";
import { ResourceType } from "../Resources";

type AppType = {
  layout: React.ReactElement;
  catchAll: React.ReactElement;
  register: (container: typeof Container) => void;
  children:
    | React.ReactElement<ResourceType>[]
    | React.ReactElement<ResourceType>;
};

const validateResourceRoutes = (
  children: React.ReactElement<ResourceType>[]
) => {
  const scannedRoutes = [] as { path: string; count: any }[];

  React.Children.forEach(children, (child) => {
    const { path } = child.props;

    if (scannedRoutes.find((r) => r.path === path)) {
      throw new Error(`Route ${path} duplicated`);
    }
  });
};

const internalRegister = (register: (container: typeof Container) => void) => {
  Container.unbindAll();

  register(Container);
};

export const AppBase = ({ register, layout, catchAll, children }: AppType) => {
  if (!Array.isArray(children)) children = [children];
  validateResourceRoutes(children);
  internalRegister(register);

  return (
    <BrowserRouter>
      <>
        {layout}
        <Routes>
          {React.Children.map(children, (resource: any) => (
            <Route
              key={resource.props.path}
              path={`${resource.props.path}/*`}
              element={resource}
            />
          ))}

          <Route path="*" element={catchAll} />
        </Routes>
      </>
    </BrowserRouter>
  );
};
